import React, { useEffect, useRef } from "react";
import UIkit from "uikit";

const InternalNoteOffcanvas = ({
  open,
  editing,
  note,
  attachments,
  saving,
  error,
  onClose,
  onNoteChange,
  onAttachmentChange,
  onRemoveAttachment,
  onSave,
}) => {
  const offcanvasRef = useRef(null);

  useEffect(() => {
    if (!offcanvasRef.current) {
      return;
    }

    const element = offcanvasRef.current;
    const handleHidden = () => {
      if (open) {
        onClose();
      }
    };

    UIkit.util.on(element, "hidden", handleHidden);

    return () => {
      UIkit.util.off(element, "hidden", handleHidden);
    };
  }, [open, onClose]);

  useEffect(() => {
    if (!offcanvasRef.current) {
      return;
    }

    const offcanvas = UIkit.offcanvas(offcanvasRef.current);
    if (open) {
      offcanvas.show();
    } else {
      offcanvas.hide();
    }
  }, [open]);

  return (
    <div
      id="messages-internal-note-offcanvas"
      ref={offcanvasRef}
      className="uk-offcanvas hms-modals"
      uk-offcanvas="flip: true; overlay: true"
    >
      <div className="uk-offcanvas-bar">
        <div className="hms-modals-main internal-note-offcanvas">
            <button
                className="uk-offcanvas-close uk-close-large"
                type="button"
                data-uk-close
            ></button>

            <div className="uk-modal-header">
                <h2 className="uk-modal-title">
                  {editing ? "Edit Internal Note" : "Internal Note"}
                </h2>
            </div>
            <div className="uk-modal-body">
                <p className="uk-margin-top secondary">
                    Internal notes are only visible to your team. Guests will never
                    see them.
                </p>
    
                {error && (
                    <div className="uk-alert-danger uk-margin-small-bottom" uk-alert="true">
                    {error}
                    </div>
                )}

                <div className="uk-margin-top">
                    <label className="uk-form-label" htmlFor="internal-note-textarea">
                    Note
                    </label>
                    <div className="uk-form-controls">
                    <textarea
                        id="internal-note-textarea"
                        className="uk-textarea"
                        rows="10"
                        placeholder="Write an internal note"
                        value={note}
                        onChange={(event) => onNoteChange(event.target.value)}
                    />
                    </div>
                </div>

                {/*
                <div className="uk-margin-top">
                  <div className="uk-flex uk-flex-middle uk-flex-between uk-margin-small-bottom">
                  <label className="uk-form-label">Attachments</label>
                  <label className="uk-button hms-btn hms-white-btn internal-note-upload-btn">
                    <input
                    type="file"
                    multiple
                    hidden
                    onChange={onAttachmentChange}
                    />
                    Add attachment
                  </label>
                  </div>

                  {!!attachments.length && (
                  <div className="internal-note-attachments">
                    {attachments.map((attachment, index) => (
                    <div
                      className="internal-note-attachment"
                      key={`${attachment.name}-${attachment.lastModified || index}`}
                    >
                      <div className="internal-note-attachment-name">
                      <FeatherIcon name="paperclip" className="msg-icon" />
                      <span>{attachment.name}</span>
                      </div>
                      <button
                      type="button"
                      className="internal-note-attachment-remove"
                      onClick={() => onRemoveAttachment(index)}
                      >
                      <FeatherIcon name="x" className="msg-icon" />
                      </button>
                    </div>
                    ))}
                  </div>
                  )}
                </div>
                */}

                <div className="uk-flex uk-flex-right uk-margin-top internal-note-actions">
                    <button
                    type="button"
                    className="uk-button hms-btn uk-offcanvas-close"
                    onClick={onClose}
                    disabled={saving}
                    >
                    Cancel
                    </button>
                    <button
                    type="button"
                    className="uk-button hms-btn hms-red-btn uk-margin-small-left"
                    onClick={onSave}
                    disabled={saving || !note.trim()}
                    >
                    {saving
                      ? "Saving..."
                      : editing
                        ? "Save Changes"
                        : "Save Internal Note"}
                    </button>
                </div>
            </div>

        </div>
      </div>
    </div>
  );
};

export default InternalNoteOffcanvas;
